import React from "react";
import { Route, Switch, Redirect } from "react-router-dom";
import { DocumentTypeRoutes } from "constants/routes";
import DocumentTypeListPage from "./DocumentTypeListPage";

const DocumentTypeRouter = () => (
  <Switch>
    <Route
      exact
      path={DocumentTypeRoutes.DocumentTypes}
      component={DocumentTypeListPage}
    />
    <Route render={() => <Redirect to={DocumentTypeRoutes.DocumentTypes} />} />
  </Switch>
);

export default DocumentTypeRouter;
